import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { Field, Input, Dropdown, Option } from "@fluentui/react-components";
import PropTypes from 'prop-types';

const FieldTableOptions = ({ fieldValues, setFieldValues, fieldIdx = 1, disabled }) => {


    const addTableColumnHeader = () => {
        const newColumn = { Id: 0, Name: '', Order: fieldValues.Table.Columns.length + 1, Type: 'String', LockStatus: 1 };
        setFieldValues({ ...fieldValues, Table: { ...fieldValues.Table, Columns: [...fieldValues.Table.Columns, newColumn] } });
    }

    const tableColumnHeaderChange = (value, columnIndex) => {
        const columns = fieldValues.Table.Columns.map((column, index) => columnIndex === index ? { ...column, Name: value } : column);
        setFieldValues({ ...fieldValues, Table: { ...fieldValues.Table, Columns: columns } });
    }

    const tableColumnHeaderLock= (value, columnIndex) => {
        const columns = fieldValues.Table.Columns.map((column, index) => columnIndex === index ? { ...column, LockStatus: value } : column);
        setFieldValues({ ...fieldValues, Table: { ...fieldValues.Table, Columns: columns } });
    }

    const tableColumnHeaderChangeType = (type, columnIndex) => {
        const columns = fieldValues.Table.Columns.map((column, index) => columnIndex === index ? { ...column, Type: type, LockStatus: type === "JSONObjectViewer" ? 5 : 1 } : column);
        setFieldValues({ ...fieldValues, Table: { ...fieldValues.Table, Columns: columns } });
    }

    const tableColumnHeaderChangeLookupValues = (values, columnIndex) => {
        const columns = fieldValues.Table.Columns.map((column, index) => columnIndex === index ? { ...column, LookupValues: values } : column);
        setFieldValues({ ...fieldValues, Table: { ...fieldValues.Table, Columns: columns } });
    }

    const removeColumnHeader = (columnIndex) => {
        setFieldValues({ ...fieldValues, Table: { ...fieldValues.Table, Columns: fieldValues.Table.Columns.filter((_, index) => columnIndex !== index) } });
    }

    const lockLabelToValue = (label) => {
        switch (label) {
            case "Completely Open":
                return 1;
            case "Semi Open":
                return 2;
            case "Closed":
                return 3;
            case "Disabled":
                return 4;
            case "Active":
                return 5;
            default:
                return 1;
        }
    }

    const valueToLockLabel = (value) => {
        switch (value) {
            case 1:
                return "Completely Open";
            case 2:
                return "Semi Open";
            case 3:
                return "Closed";
            case 4:
                return "Disabled";
            case 5:
                return "Active";
            default:
                return "Completely Open";
        }
    }

    const typeLabelToValue = (label) => {
        switch (label) {
            case "General":
                return 'String';
            case "Date (YYYY/MM/DD)":
                return 'Date';
            case "Numeric":
                return 'Numeric';
            case "List":
                return 'Lookup';
            case "Object Viewer":
                return 'JSONObjectViewer';
            default:
                return label;
        }
    }

    const typeValueToLabel = (value) => {
        switch (value) {
            case 'String':
                return 'General';
            case 'Date':
                return 'Date (YYYY/MM/DD)';
            case 'Numeric':
                return 'Numeric';
            case 'Lookup':
                return 'List';
            case 'JSONObjectViewer':
                return 'Object Viewer';
            default:
                return value;
        }
    }

    return (
        <div>
            <Field label="Default Table Headers (from left to right)" size="medium" />

            {fieldValues.Table.Columns.map((column, columnIndex) => {
                return <>
                    <Form.Group className="option-input" id={"dynamicTableDesigner" + fieldIdx + "_" + columnIndex}>
                        {console.log(column)}
                        <Input
                            value={column.Name}
                            onChange={(e) => tableColumnHeaderChange(e.target.value, columnIndex)}
                            placeholder={`Table header ${columnIndex + 1}`}
                            disabled={disabled}
                        />

                        <Dropdown
                            className="ml-4"
                            value={typeValueToLabel(column.Type)}
                            onOptionSelect={(_, data) => {
                                tableColumnHeaderChangeType(typeLabelToValue(data.optionValue), columnIndex)
                            }}
                            disabled={disabled}
                        >
                            <Option value="String">General</Option>
                            <Option value="Date">Date (YYYY/MM/DD)</Option>
                            <Option value="Numeric">Numeric</Option>
                            <Option value="Lookup">List</Option>
                            <Option value="JSONObjectViewer">Object Viewer</Option>
                        </Dropdown>
                         <Dropdown
                            className="ml-4"
                            value={valueToLockLabel(column.LockStatus)}
                            onOptionSelect={(_, data) => {
                                tableColumnHeaderLock(lockLabelToValue(data.optionValue), columnIndex)
                            }}
                            disabled={disabled}
                        >
                            { column.Type === "JSONObjectViewer" ? 
                                <Option value="Active">Active</Option> :
                                <>
                                    <Option value="Completely Open">Completely Open</Option>
                                    <Option value="Semi Open">Semi Open</Option>
                                    <Option value="Closed">Closed</Option>
                                </>
                            }                            
                            <Option value="Disabled">Disabled</Option>
                        </Dropdown>
                        <Button
                            data-testid={`delete-table${columnIndex}`}
                            className="btn-icon1 delete"
                            onClick={() => removeColumnHeader(columnIndex)}
                            type="button"
                            disabled={disabled}
                        />
                    </Form.Group>
                    {column.Type === "Lookup" && <Form.Group className="options-input pl-5">
                        <Field label="Options" size="medium" required>
                            <Input
                                value={column.LookupValues}
                                disabled={disabled}
                                onChange={(e) => tableColumnHeaderChangeLookupValues(e.target.value, columnIndex)}
                                placeholder="e.g. Option 1, Option 2, Option 3 ..."
                            />
                        </Field>
                    </Form.Group>}
                </>
            })}

            <Form.Group className="option-input">
                <Button onClick={() => addTableColumnHeader()} disabled={disabled}>
                    + Add header item
                </Button>
            </Form.Group>

        </div>
    );
}

FieldTableOptions.propTypes = {
    fieldValues: PropTypes.shape({
        Table: PropTypes.shape({
            Columns: PropTypes.arrayOf(PropTypes.shape({
                Type: PropTypes.string,
                LookupValues: PropTypes.string,
            })),
        }),
    }).isRequired,
    setFieldValues: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    fieldIdx: PropTypes.number,
};

export default FieldTableOptions;